import Vue from 'vue'
import Vuex from 'vuex'
import {
  mutations
} from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

const state = {
  user: {
    id: '',
    login: ''
  },
  maps: [],
  menu: {
    active: false
  },

  footer: {
    active: false
  },

  sidebar: {
    active: false
  },
  params: {
    ignKey: 'choisirgeoportail'
  },

  ign: 'GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2',
  questionnaire: null,
  rayonLte: 2000,
  rayonTnt: 30000

}

export default new Vuex.Store({
  state,
  mutations,
  actions
})